import React, { useState } from 'react';
import { Avatar } from 'antd';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { InfoWraper, NavAuth, UserDropDwon } from './auth-info-style';
import Message from './message';
import Notification from './notification';
import Settings from './settings';
import Support from './support';
import { Popover } from '../../popup/popup';
import { Dropdown } from '../../dropdown/dropdown';

import { logOut } from '../../../redux/authentication/actionCreator';
import Heading from '../../heading/heading';

const AuthInfo = ({ rtl }) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    flag: 'english',
  });
  const { flag } = state;

  //const userId = useSelector((state) => state.auth.userId);
  const user = useSelector(state => state.auth);
  const isLoading = useSelector(state => state.auth.loading);
  const updateUrlArray = (array, index, newValue) => {
    const newArray = [...array]; // Create a copy of the array
    newArray[index] = newValue; // Update the specific element
    return newArray;
  };
  
  const constructUrl = (array) => {
    return array.join('/');
  };
  if (user.userId === undefined) {
    setTimeout(function() {
      window.location.reload();
    }, 1000); // Delay of 1000 milliseconds (1 second)
  } else {
    const currentUrl = window.location.href;
    const get_url = currentUrl.split('/');
    const get_name_url = get_url[2]
    const userId = [32071, 80633, 90199,11442];
    const user_new = userId.includes(user.userId) ? true : false;
    const url_local_host = 'localhost:3000'
    if(user_new && get_name_url === 'franchise.fastship.co' ){
      const newElement = "dev-franchise.fastship.co";
      const updatedArray = updateUrlArray(get_url, 2, newElement);
      const newUrl = constructUrl(updatedArray);
      window.open(newUrl, '_self');
    }
  }
  const SignOut = e => {
    e.preventDefault();
    dispatch(logOut());
  };

  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">
        <figure className="user-dropdwon__info">
          <img src={'https://app.fastship.co/images/fasty_help.png'} alt="" width="60" />
          <figcaption>
            <Heading as="h5">{isLoading ? 'Loading...' : user?.name}</Heading>
            <p>{isLoading ? 'Loading...' : user?.email}</p>
          </figcaption>
        </figure>
        <ul className="user-dropdwon__links">
          <li>
            <Link to="/admin/pages/mycredit">
              <FeatherIcon icon="dollar-sign" /> ประวัติการเงิน
            </Link>
          </li>
        </ul>
        <ul className="user-dropdwon__links" style={{ display: 'none' }}>
          <li>
            <Link to="#">
              <FeatherIcon icon="user" /> ข้อมูลส่วนตัว
            </Link>
          </li>
          <li>
            <Link to="#">
              <FeatherIcon icon="settings" /> ตั้งค่า
            </Link>
          </li>
          <li>
            <Link to="#">
              <FeatherIcon icon="dollar-sign" /> เติมเงิน
            </Link>
          </li>
          <li>
            <Link to="#">
              <FeatherIcon icon="bell" /> ช่วยเหลือ
            </Link>
          </li>
        </ul>
        <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
          <FeatherIcon icon="log-out" /> ออกจากระบบ
        </Link>
      </div>
    </UserDropDwon>
  );

  const onFlagChangeHandle = value => {
    setState({
      ...state,
      flag: value,
    });
  };

  const country = (
    <NavAuth>
      <Link onClick={() => onFlagChangeHandle('english')} to="#">
        <img src={require('../../../static/img/flag/english.png')} alt="" />
        <span>English</span>
      </Link>
      <Link onClick={() => onFlagChangeHandle('germany')} to="#">
        <img src={require('../../../static/img/flag/germany.png')} alt="" />
        <span>Germany</span>
      </Link>
      <Link onClick={() => onFlagChangeHandle('spain')} to="#">
        <img src={require('../../../static/img/flag/spain.png')} alt="" />
        <span>Spain</span>
      </Link>
      <Link onClick={() => onFlagChangeHandle('turky')} to="#">
        <img src={require('../../../static/img/flag/turky.png')} alt="" />
        <span>Turky</span>
      </Link>
    </NavAuth>
  );

  return (
    <InfoWraper>
      {/* <Message /> */}
      {/* <Notification /> */}

      {/* <Settings /> */}
      {/* <Support /> */}

      {/*
      <div className="nav-author">
        <Dropdown placement="bottomRight" content={country} trigger="click">
          <Link to="#" className="head-example">
            <img src={require(`../../../static/img/flag/${flag}.png`)} alt="" />
          </Link>
        </Dropdown>
      </div>
      */}

      <div className="nav-author">
        <Popover placement="bottomRight" content={userContent} action="click">
          <Link to="#" className="head-example">
            <Avatar src={'/sqlogo.png'} />
          </Link>
        </Popover>
      </div>
    </InfoWraper>
  );
};

export default AuthInfo;
